"use client";
import { useEffect, useState } from "react";
import { useDrawerContext } from "../../context/drawerContext";

export default function ConnectionDrawer() {
  const { setOpen } = useDrawerContext();
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  useEffect(() => {
    const checkConnection = () => {
      setIsOnline(navigator.onLine);
      if (navigator.onLine) {
        setTimeout(() => setOpen(false), 2000); // ✅ Auto-close drawer after 2 sec
      }
    };
    window.addEventListener("online", checkConnection);
    return () => window.removeEventListener("online", checkConnection);
  }, [setOpen]);

  return (
    <div className="w-full">
      <div className="flex items-center justify-between w-full">
        <br />
        {isOnline ? (
            <h3 className="text-green-600">You're Back Online!</h3>
        ) : (
            <h3 className="text-red-600">No Internet Connection</h3>
        )}
        <br />
      </div>
      <div className="mt-6 flex flex-col gap-2 justify-stretch">
        {isOnline ? (
          <>
            <p className="text-sportsDarkGrey mb-[26px]">
              Connection restored. We are now resuming your app experience...
            </p>
          </>
        ) : (
          <>
            <p className="text-sportsDarkGrey mb-[26px]">
                Please check your internet connection, once we've detected a stable connection you'll be able to resume your use of the app.
            </p>
          </>
        )}
      </div>
    </div>
  );
}